import React, { useCallback } from 'react';
import { Box, Flex } from '@withjoy/joykit';
import { ProductCatalogSearchQueryOrderBy } from '@graphql/generated';
import { ExtendedSelect, MobileContainer, styles } from './SortByPriceMobile.styles';
import { ReactComponent as Reorder } from '@assets/icons/reorder.svg';
import { useSortByPrice } from '../SortByPrice.controller';
import { SortByPriceArgs } from '../SortByPrice.types';
import { useTranslation } from '@shared/core';

const SortByPriceMobile = ({ value, onChange }: SortByPriceArgs) => {
  const { options } = useSortByPrice();
  const { t } = useTranslation('catalogRegistry');
  const { sort } = t('refinementsPanel');

  const defaultValue = ProductCatalogSearchQueryOrderBy.featured;

  const handleMobileChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      const optionValue = event.target.value as ProductCatalogSearchQueryOrderBy;
      if (optionValue) {
        onChange?.(optionValue);
      }
    },
    [onChange],
  );

  return (
    <MobileContainer __css={styles.mobileContainer}>
      <Flex __css={styles.mobileSelectLabel}>
        <Reorder style={{ fill: 'white' }} />
        {sort()}
      </Flex>
      <ExtendedSelect
        as="select"
        __css={styles.mobileSelect}
        defaultValue={defaultValue}
        value={value ?? defaultValue}
        onChange={handleMobileChange}
      >
        {options.map(({ value: optionValue, label }) => (
          <Box
            as="option"
            key={optionValue}
            value={optionValue}
          >
            {label}
          </Box>
        ))}
      </ExtendedSelect>
    </MobileContainer>
  );
};

export { SortByPriceMobile };
